import { render } from "./UserHeader.vue?vue&type=template&id=e3bc2ce0&scoped=true"
import script from "./UserHeader.vue?vue&type=script&lang=js"
export * from "./UserHeader.vue?vue&type=script&lang=js"

import "./UserHeader.vue?vue&type=style&index=0&id=e3bc2ce0&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e3bc2ce0"]])

export default __exports__